<template>
  <div class="create-analyzer-type">
    <div class="header">
      <h2>Choose Model Type</h2>
    </div>
    <div class="options">
      <div :class="['card', 'card-action', analyzer.id === selected ? 'card-action-selected': '', analyzer.enabled ? '' : 'disabled']" 
        v-for="analyzer in analyzers" :key="analyzer.id"
        @click="selectAnlyzer(analyzer)"
        >
        <h3>{{ analyzer.name }}</h3>
        <p>{{ analyzer.description }}</p>
        <div>
          <h4>Pros</h4>
          <p class="procon" v-for="pro in analyzer.pros" :key="pro">- {{ pro }}</p>
        </div>
        <div>
          <h4>Cons</h4>
          <p class="procon" v-for="pro in analyzer.cons" :key="pro">- {{ pro }}</p>
        </div>
        
        <div v-if="analyzer.id === selected" class="selected-label">Selected</div>
        <div v-if="!analyzer.enabled" class="selected-label">Not Available Yet</div>
      </div>
    </div>
    <div class="next">
      <button class="empty" @click="$router.push('/models')">Back</button>
      <button @click="next" :disabled="!selected">Next</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AnalyzerType',
  props: {
    analyzer: Object
  },
  data () {
    return {
      selected: null,
      analyzers: [
        {
          id: 'rag',
          name: 'RAG Model',
          enabled: true,
          description: 'Creates an AI model trained on the provided dataset. Perfect for generally large text analysis with coupled datasets.',
          pros: [
            'Can be used to analyze a large amount of data',
            'Can analyze large datasets and make connections accross them',
            'Accuracy is very high and repsonses are clear and cohesive.',
          ],
          cons: [
            'More expensive to generate the model',
            'Takes longer to generate the model',
            'Can be difficult to interpret results'
          ]
        },
        {
          id: 'sam',
          name: 'Subsequent Aggregation Model',
          enabled: false,
          description: 'Performs subsequent prompts on the provided dataset and returns the results. Should be used on low coupling datasets to find specific information.',
          pros: [
            'Can be used to analyze a large amount of data',
            'Cost grows linearly with data length',
            'Accuracy is very high.',
          ],
          cons: [
            'Responses will be cluttered',
            'Responses will not be cohesive among chunks.',
            'Using chat history will cost context and costs.'
          ],
        },
        {
          id: 'pqm',
          name: 'Plain Query Model',
          enabled: false,
          description: 'Beforms one prompt on the provided dataset and returns the results.',
          pros: [
            'Can be used to generate small amounts of data',
            'Very cheap to generate the model',
            'Accuracy is very high.',
          ],
          cons: [
            'Can only be used for very small datasets',
            'Using chat history will cost context and costs.',
          ],
        }
      ]
    }
  },
  methods: {
    next () {
      this.$emit('update', {
        analyzerType: this.selected
      });
      this.$router.push('/models/create/models_sources');
    },
    selectAnlyzer (analyzer) {
      if (analyzer.enabled) {
        this.selected = analyzer.id;
      }
    }
  },
  created () {
    this.selected = this.analyzer.analyzerType;
  }
}
</script>

<style scoped>

.create-analyzer-type {

}



</style>



// WEBPACK FOOTER //
// src/components/CreateModelFlow/AnalyzerType.vue